module.exports = __webpack_public_path__ + "img/bg-image-15.80eb2b2a.jpg";